import { render, staticRenderFns } from "./Afiliate.vue?vue&type=template&id=47aa5107&scoped=true&lang=pug&"
import script from "./Afiliate.vue?vue&type=script&lang=js&"
export * from "./Afiliate.vue?vue&type=script&lang=js&"
import style0 from "./Afiliate.vue?vue&type=style&index=0&id=47aa5107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa5107",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47aa5107')) {
      api.createRecord('47aa5107', component.options)
    } else {
      api.reload('47aa5107', component.options)
    }
    module.hot.accept("./Afiliate.vue?vue&type=template&id=47aa5107&scoped=true&lang=pug&", function () {
      api.rerender('47aa5107', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/Afiliate.vue"
export default component.exports